import { call, put, select, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from 'typesafe-actions';
import { LOG_OUT, SET_AUTH } from '../actions/auth';
import {
  actionSetLimitOrders,
  ACTION_GET_LIMIT_ORDERS,
  ACTION_DELETE_LIMIT_ORDER,
  actionDeletedLimitOrder,
  ACTION_UPDATE_LIMIT_ORDER_PRICE,
  actionAfterUpdateLimitOrderPrice,
  IDeleteLimitOrderPayload,
  IUpdateLimitOrderPayload,
  IGetLimitOrdersPayload,
  actionGetLimitOrders,
} from '../actions/limit_orders';
import { actionCreateNotification } from '../actions/notifications';
import { IStore } from '../reducers';
import { authTokenSelector } from '../selectors/auth';
import { LimitOrderAPI } from '../store/createStore';

function* onGetLimitOrders(
  action: PayloadAction<any, IGetLimitOrdersPayload>
): any {
  const { wallet, token } = action.payload;

  try {
    const data: any = yield call(LimitOrderAPI.get, wallet, token);

    if (data) {
      yield put(actionSetLimitOrders(data));
    } else {
      console.warn('Could not load limit orders');
      yield put(actionSetLimitOrders([]));
    }
  } catch (err) {
    yield put(actionSetLimitOrders([]));
    console.error(err);
  }
}

function* onDeleteLimitOrder(
  action: PayloadAction<any, IDeleteLimitOrderPayload>
): any {
  try {
    const data: any = yield call(
      LimitOrderAPI.remove,
      action.payload.data,
      action.payload.token
    );
    if (data) {
      yield put(
        actionCreateNotification({ kind: 'info', message: 'Order canceled' })
      );
      // Call reducer
      yield put(actionDeletedLimitOrder(action.payload));
    } else {
      yield put(
        actionCreateNotification({
          kind: 'warning',
          message: 'Something went wrong',
        })
      );
    }
  } catch (err) {
    console.error(err);
  }
}

function* onUpdateLimitOrder(
  action: PayloadAction<any, IUpdateLimitOrderPayload>
): any {
  try {
    const data: any = yield call(
      LimitOrderAPI.update,
      action.payload.data,
      action.payload.token
    );
    if (data) {
      yield put(
        actionCreateNotification({ kind: 'info', message: 'Order updated' })
      );
      // Call reducer
      yield put(actionAfterUpdateLimitOrderPrice(action.payload));
    } else {
      yield put(
        actionCreateNotification({
          kind: 'warning',
          message: 'Something went wrong',
        })
      );
    }
  } catch (err) {
    console.error(err);
  }
}

function* onAuth(): any {
  try {
    const token = yield select(authTokenSelector);
    const { wallet } = yield select((store: IStore) => store.auth);

    yield put(
      actionGetLimitOrders({
        token,
        wallet,
      })
    );
  } catch (error) {
    console.error(error);
  }
}

function* onLogOut(): any {
  try {
    yield put(actionSetLimitOrders([]));
  } catch (error) {
    console.error(error);
  }
}

export default function* limitOrdersSaga() {
  yield takeLatest(SET_AUTH, onAuth);
  yield takeLatest(LOG_OUT, onLogOut);
  yield takeLatest(ACTION_GET_LIMIT_ORDERS, onGetLimitOrders);
  yield takeLatest(ACTION_DELETE_LIMIT_ORDER, onDeleteLimitOrder);
  yield takeLatest(ACTION_UPDATE_LIMIT_ORDER_PRICE, onUpdateLimitOrder);
}
